const invertedMessages = {
  'Rule removed successfully': 'external.rules.removeSuccess',
  'Applies to': 'external.rules.appliesTo',
  'External Users': 'external.rules.tabContent.externalUsers',
  'You have reached the maximum limit of {maxRuleCount} rules.':
    'external.rules.maxLimit.message',
  'A new rule is already in progress. Please complete it before creating another one.':
    'external.rules.newRuleInProgress.message',
  'New Rule': 'external.rules.newRule',
  'Users will be classified according to this rule':
    'external.rules.notClassified',
};

export default invertedMessages;
